module.exports = __webpack_public_path__ + "img/3.41d94ae3.jpg";